<router-outlet></router-outlet>

<ng-template #subsubmenuContent>
    <div class="subSideMenu">
        <ul class="list-none px-3">
            <ng-container
                *ngTemplateOutlet="itemGroup;
                context: { itemGroup: items() }"
            ></ng-container>
        </ul>
    </div>
</ng-template>

<ng-template #itemGroup let-itemGroup="itemGroup">
    @for (item of itemGroup; track item) {
        <li class="subSideMenu-item">
            <div
                pRipple
                [ngClass]="['subSideMenu-link', isItemActive(item) ? 'subSideMenu-link_active' : '']"
                (click)="itemOnClick(item.path)"
            >
                <span>{{ item.label | translate }}</span>
                @if (item.children?.length) {
                    <i class="pi ml-2" [class.pi-angle-down]="isItemActive(item)" [class.pi-angle-right]="!isItemActive(item)"></i>
                }
            </div>
            @if (item.children?.length && isItemActive(item)) {
                <ul class="list-none subSideMenu-children">
                    @for (child of item.children; track child.key) {
                        <li class="subSideMenu-item">
                            <div
                                pRipple
                                [ngClass]="['subSideMenu-link', 'subSideMenu-link_child', activePath() === child.path ? 'subSideMenu-link_active' : '']"
                                (click)="itemOnClick(child.path)"
                            >
                                {{ child.label | translate }}
                            </div>
                        </li>
                    }
                </ul>
            }
        </li>
    }
</ng-template>
